import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { useFpB2bProductCatalogProducts } from '@cart-services/hooks/fp-b2b/use-fp-b2b-product-catalog-products'
import { DialogSelectAddonProductVariationContent, type DialogSelectAddonProductVariationContentProps } from '@cart-ui/DialogSelectAddonProductVariationContent/DialogSelectAddonProductVariationContent'
import { type ProjectCode } from '@constants'
import { useDialog } from '@dni-hooks/useDialog'
import { DialogHeader } from '@pets-ui/DialogHeader/DialogHeader'
import { ResponsiveDialog } from '@pets-ui/ResponsiveDialog/ResponsiveDialog'
import { useMemo } from 'react'
import { useStmCart } from '../../CartProvider'

export const DIALOG_SELECT_ADDON_PRODUCT_VARIATION = 'DIALOG_SELECT_ADDON_PRODUCT_VARIATION'

export interface DialogSelectAddonProductVariationProps {
  parentProductId: number
  productProjectCode: ProjectCode
  currency?: string
}

export const DialogSelectAddonProductVariation = () => {
  const { parentProductId, productProjectCode, currency, open, closeDialog } = useDialog<DialogSelectAddonProductVariationProps>(DIALOG_SELECT_ADDON_PRODUCT_VARIATION)
  const { campaignId, campaignCode, platform } = useStmCart()
  const { upsertCartItem } = useFpB2bCartService(campaignId, platform)
  const { productCatalogDto } = useFpB2bProductCatalogProducts(campaignId, productProjectCode, campaignCode, platform)

  const handleSubmit: DialogSelectAddonProductVariationContentProps['onSubmit'] = (selectedVariation, quantity) => {
    if (selectedVariation) {
      upsertCartItem({
        ...selectedVariation,
        cartItemId: selectedVariation.variation_id,
        quantity,
      })
    }
    closeDialog()
  }

  const allProductDto = useMemo(() => {
    const products = productCatalogDto?.products.flatMap(product => product.all_product)
    return products?.find(product => product.id === parentProductId)
  }, [productCatalogDto, parentProductId])

  return (
    <ResponsiveDialog
      open={open}
      onClose={closeDialog}
    >
      <DialogHeader title="加價購商品" onClose={closeDialog} />
      <DialogSelectAddonProductVariationContent
        variationsGroupByFirstLevelButton={allProductDto?.variationsGroupByFirstLevelButton}
        currency={currency}
        onSubmit={handleSubmit}
      />
    </ResponsiveDialog>
  )
}
